import { TradeType } from '@shared/models';

import { BadgeConfig } from './badge.consts';

export const TRADE_TYPE_BADGE: Record<TradeType, BadgeConfig> = {
  [TradeType.Other]: { icon: 'pi-ellipsis-h', color: 'gray' },
  [TradeType.Plumbing]: { icon: 'pi-wrench', color: 'blue' },
  [TradeType.Electricity]: { icon: 'pi-bolt', color: 'yellow' },
  [TradeType.Building]: { icon: 'pi-building', color: 'orange' },
  [TradeType.Ventilation]: { icon: 'pi-cloud', color: 'teal' },
};
